The identifier for the `AdvertisementBranding` to apply to the posted job ad.

Scheme requirements:

- For the `seekAnz` scheme, this field's behavior is dependent on the `AdvertisementProductFeatures` of the product set in the `seekAdvertisementProductId` field.

  When the product's `AdvertisementProductFeatures.branding` value is null, this field will be silently ignored.
